import { css } from '@emotion/css';
import { Popover } from 'react-text-selection-popover';
import './textSelectionPopover.css'

const TextSelectionPopover = ({ onAskLima, onSummarize }) => {
  return (
    <Popover
      render={({ clientRect, isCollapsed, textContent }) => {
        if (!clientRect || !textContent?.trim()) return null;

        const endsWithSentence = /[.!?]["')\]]?\s*$/.test(textContent.trim());

        const styles = {
          popoverContainer: css`
        position: absolute;
        left: ${clientRect.left + clientRect.width / 2}px;
        top: ${clientRect.top + window.scrollY - 40}px;
        transform: translateX(-50%);
        z-index: 999;
        pointer-events: auto;
      `,
        };

        return (
          <div className={`text-selection-popover ${styles.popoverContainer}`}>
            <button className="popover-button ask-lima" onClick={() => onAskLima(textContent)}>
              Ask Lima
            </button>
            <br />
            {endsWithSentence ? (
              <button className="popover-button summarize" onClick={() => onSummarize(textContent)}>
                Summarize
              </button>
            ) : (
              <button
                className="popover-button summarize"
                disabled
                title="Highlight a full sentence to summarize"
              >
                Summarize
              </button>
            )}
            <br />
          </div>
        );
      }}
    />

  );
};

export default TextSelectionPopover;
